export const BASE_URL = "https://serverless-api.akpatil36.workers.dev";
